// noinspection JSNonASCIINames,NonAsciiCharacters

export const invoiceTranslations = {
    invoice_list: {
        inv_from: "Arved alates",
        inv_to: "Arved kuni",
        invalid_date_range: "Vigane kuupäevavahemik",
        max_allowed_period: "Maksimaalne lubatud periood on 365 päeva",
        period: {
            this_month: "Käesolev kuu",
            prev_month: "Eelmine kuu",
            this_year: "Käesolev aasta",
            prev_year: "Eelmine aasta",
        },
        columns: {
            invoice_no: "Arve nr",
            date: "Kuupäev",
            due: "Tähtaeg",
            customer: "Klient",
            vendor: "Tarnija",
            total: "Kokku",
            paid: "Makstud",
        },
        lock_reason: {
            has_payments: "Arveid, mille eest on tehtud maksed, ei saa kustutada..<br/>Palun võtke ühendust oma raamatupidajaga, kui soovite selle kustutada",
            too_old: "Vanasid arveid ei saa kustutada..<br/>Palun võtke ühendust oma raamatupidajaga, kui soovite selle kustutada",
            created_ext: "Välises süsteemis loodud arveid ei saa kustutada.<br/>Palun võtke ühendust oma raamatupidajaga, kui soovite selle kustutada",
        }
    },
    single_invoice: {
        inv_number: "Arve nr #",
        date: "Kuupäev",
        due: "Tähtaeg",
        party: {
            "Invoice from": "Arve saatja",
            "Invoice to": "Arve saaja",
        },
        conversion_alert: "Arve loodi välises süsteemis.<br/>PDF-i genereerimine teisendab selle sisemiseks vormingus",
        download_invoice: "Lae arve alla",
        duplicate_invoice: "Kopeeri arve",
        send_via_email: "Saada e-postiga",
        email_sent_successfully: "E-kiri saadeti edukalt!",
        table: {
            description: "Kirjeldus",
            quantity: "Kogus",
            unit: "Ühik.",
            price: "Hind",
            disc_pct: "Allahindlus %",
            total_no_vat: "Kokku ilma KM-ta",
            vat_total: "Kogu KM",
            vat: "KM",
            total: "Kokku",
        },
        amount_to_pay: "Maksmiseks kokku",
    },
    send_invoice_via_email: {
        title: "Saada arve",
        to: "Arve saaja (e-posti aadress)",
        subject: "Kirja pealkiri",
        body: "Kirja sisu",
        file_name: "Manuse nimi",
        copy_to: "Saada koopia (aadresside loetelu, eraldatud komadega)",
        email_header: "Arve {{invoiceNo}} firmast {{companyName}}",
        email_body: "Tere,\n\nArve on kirja manuses.\n\nParimate soovidega,\n{{companyName}}"
    },
    invoice_wizard: {
        customer_step: {
            header: "Klient",
            subtitle: "Palun valige klient, kellele arve esitate või looge uus",
            new_customer: "Loo uus",
            select_customer: "Valige klient",
            add_new_customer_question: "Kas soovite luua uue kliendi?",
            clear_data: "Kustutab kõik varem sisestatud andmed, sealhulgas arve read",
        },
        invoice_content_step: {
            header: "Arve sisu",
            invoice_to: "Arve saaja",
            inv_number: "Arve number",
            inv_number_was_used: "On juba kasutatud",
            date: "Kuupäev",
            due: "Tähtaeg",
            currency: "Valuuta",
            lines: {
                item_service: "Toode/Teenus",
                description: "Kirjeldus",
                description_too_long: "Kirjeldus on liiga pikk",
                quantity: "Kogus",
                unit: "Ühik.",
                price: "Hind",
                disc_pct: "Allahindlus %",
                total_no_vat: "Kokku ilma KM-ta",
                vat: "KM",
                actions: "Tegevused",
            },
            comment: "Kommentaar",
            comment_too_long: "Kommentaar on liiga pikk",
            comment_placeholder: "Palun lisage arvega seotud kommentaar",
            new_line: "Uus rida",
            skip_preview: "Jäta vahele ja loo arve",
            tax_rate_warning: "Olete valinud käibemaksumääraks 22%, kuigi arve kuupäev on pärast 1. juulit 2025.<br/>Alates 1. juulist 2025 on Eestis käibemaksumäär 24%.<br/>Kui teil on selle kohta küsimusi, võtke ühendust meie klienditoega.<br/>"
        },
        new_invoice_header: "Uus arve",
        create_invoice: "Loo arve"
    },
}